export function Brand() {
  return (
    <a className="brand" href="/" aria-label="GeoStream home">
      <img src="/geostream-mark.png" alt="" width={42} height={42} />
      <span>GeoStream</span>
    </a>
  );
}

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="shell header-inner">
        <Brand />
        <nav className="primary-nav" aria-label="Primary navigation">
          <a href="/#platform">Platform</a>
          <a href="/#memberships">Memberships</a>
          <a href="/#company">Company</a>
          <a href="/downloads">Downloads</a>
          <a href="/login">Sign in</a>
        </nav>
        <a className="button button-compact button-primary" href="/downloads">
          Get the beta
        </a>
      </div>
    </header>
  );
}

export function SponsorSlot({
  eyebrow,
  title,
  description,
  compact = false,
}: {
  eyebrow: string;
  title: string;
  description: string;
  compact?: boolean;
}) {
  return (
    <aside className={`partner-slot${compact ? " partner-slot-compact" : ""}`} aria-label="Future sponsor placement">
      <div className="partner-label">Future sponsor placement</div>
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <span className="partner-availability">Commercial sponsorship · planned</span>
    </aside>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div className="footer-brand">
          <Brand />
          <p>Independent broadcast software built for reliable shows, adaptable audiences, and creator-owned growth.</p>
        </div>
        <div className="footer-links">
          <div>
            <strong>Product</strong>
            <a href="/#platform">Platform</a>
            <a href="/#memberships">Memberships</a>
            <a href="/downloads">Downloads</a>
          </div>
          <div>
            <strong>Company</strong>
            <a href="/#company">Company</a>
            <a href="/#faq">Questions</a>
            <span>Public beta in progress</span>
          </div>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© 2026 GeoStream</span>
        <span>Core broadcasting stays free. Paid memberships are not active yet.</span>
      </div>
    </footer>
  );
}
